import TemplateView from '../TemplateView'
import BalanceRulesEditorContent from './BalanceRulesEditorContent'
import {BalanceRulesManager} from './BalanceRulesEditor'

export default class BalanceRulesEditorDialogContent extends TemplateView {
    constructor({
        leaveBalanceTypePrefix = '',
        balanceDefaults,
        countHoursPerDay,
        parameters
    }) {
        super()
        this.props = {
            leaveBalanceTypePrefix,
            balanceDefaults,
            countHoursPerDay,
            parameters
        }
    }

    templateHtml() {
        return "<div id='<%=prefix%>_balanceRulesDescriptionTooltip' class='balanceRulesDescriptionTooltip'>" +
               "    <div>" +
               "        <span class='defaultRules'></span>" +
               "        <span class='customRules'></span>" +
               "    </div>" +
               "    <div class='rules'>" +
               "        <div class='readOnlyResetRule'></div>" +
               "        <div class='readOnlyAccrualRule'></div>" +
               "        <div class='readOnlyCapRule'></div>" +
               "    </div>" +
               "</div>" +
               "<div id='<%=prefix%>_balanceRulesEditorDialog' class='balanceRulesEditorDialog'>" +
               "    <div>" +
               "        <span class='userDefaultRulesSpan'></span>" +
               "        <div class='switcherPlaceholder'></div>" +
               "    </div>" +
               "    <div class='leaveBalanceRulesPlaceholder'></div>" +
               "    <div>" +
               "        <span class='defaultBalanceNote'></span>" +
               "    </div>" +
               "</div>"
    }

    templateModel() {
        return {
            prefix: this.props.leaveBalanceTypePrefix,
        }
    }

    afterRender() {
        this.$balancePlaceholder = this.find('.leaveBalanceRulesPlaceholder')
        this.editor = new BalanceRulesEditorContent({
            leaveBalanceTypePrefix: this.props.leaveBalanceTypePrefix
        }).init(this.$balancePlaceholder)

        this.balanceRulesManagerActions = new BalanceRulesManager().init(
            this.props.leaveBalanceTypePrefix,
            this.props.balanceDefaults,
            this.props.countHoursPerDay,
            this.props.parameters
        )
    }

    getDialogValues() {
        return this.balanceRulesManagerActions.getDialogValues()
    }

    hideDialog() {
        this.balanceRulesManagerActions.hideDialog()
    }

    updateDialog(balanceData) {
        this.balanceRulesManagerActions.updateDialog(balanceData)
    }

    setModifyBalanceAccrualRulesOkClick(onClickCallback) {
        this.balanceRulesManagerActions.setModifyBalanceAccrualRulesOkClick(onClickCallback)
    }

    setOnCloseCallback(callback) {
        this.balanceRulesManagerActions.setOnCloseCallback(callback)
    }

    showDialogAt(targetCell, offset) {
        this.balanceRulesManagerActions.showDialogAt(targetCell, offset)
    }

    reinitAccrualRulesControls(countHoursPerDay) {
        this.balanceRulesManagerActions.reinitAccrualRulesControls(countHoursPerDay)
    }

    showAccrualRulesTooltip(e, data) {
        this.balanceRulesManagerActions.showAccrualRulesTooltip(e, data)
    }

    moveAccrualRulesTooltip(e) {
        this.balanceRulesManagerActions.moveAccrualRulesTooltip(e)
    }

    hideAccrualRulesTooltip() {
        this.balanceRulesManagerActions.hideAccrualRulesTooltip()
    }
}



// WEBPACK FOOTER //
// ./web/js/controls/BalanceRulesEditorDialogContent.js